@if (contentTemplate) {
  <ng-template
    [ngTemplateOutlet]="contentTemplate"
    [ngTemplateOutletContext]="{
      data: data,
      popover: popoverControl,
      anchorElement: anchorElement,
      position: {
        alignStart: computedAlignStart,
        alignEnd: computedAlignEnd,
        direction: computedDirection,
        initDirection: direction,
      },
    }"></ng-template>
}
@if (pplPopoverComponent) {
  <ng-container #tooltip></ng-container>
}
